module.exports = __webpack_public_path__ + "img/fhqr.4d37c367.png";